import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            alignSelf: 'stretch',
            padding: remCalc(16),
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            backgroundColor: 'background.default',
            alignItems: 'flex-start',
            gap: remCalc(10),
        },
        combo: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        label: {
            width: remCalc(56),
            maxWidth: remCalc(168),
            py: remCalc(6),
            px: remCalc(8),
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(12),
            border: 'none',
            color: 'label.text.secondary',
            backgroundColor: 'label.background.secondary',
            fontWeight: 'bold',
            textStyle: 'body-xxsmall',
            textTransform: 'uppercase',
        },
        bodycopy: {
            color: 'text.default',
            fontWeight: 'normal',
            textStyle: 'body-small',
        },
    },
}
